"use client";
import { twMerge } from "tailwind-merge";
import { getClasses, getQuestIcons } from "../helpers";
import { QuestPoints } from "../QuestPoints";
import { CompletedQuestDto } from "@/api/quests/types";
import { Tooltip } from "@/app/(components)/Basic/Tooltip";
import { QuestLink } from "../QuestLink";
import { CompleteQuestCount } from "../CompleteQuestCount";
import { useMemo } from "react";

export interface Props {
  quest: CompletedQuestDto;
  disableLink?: boolean;
  completed?: boolean;
}

const QuestCard = ({ quest, disableLink, completed = false }: Props) => {
  const questColor = quest.isLocked ? "endemicGray-500" : quest.color!;
  const { textClass } = getClasses(quest.isLocked ? "gray" : quest.color!);
  const { smallIcon, icon } = getQuestIcons(quest.type, questColor);

  const isCompletedRecurringQuest = useMemo(
    () => quest.recurring === true && quest.completedCount,
    [],
  );

  return (
    <Tooltip
      className="w-full max-w-[387px]"
      text={
        quest.isLocked
          ? "Can't access this quest yet—it's locked until you complete the active tasks."
          : null
      }
      tooltipClassName={quest.isLocked ? "w-44" : "hidden"}
      position={["center", "top"]}
    >
      <QuestLink quest={quest} disableLink={disableLink}>
        <div className="flex items-center justify-between w-full">
          <QuestPoints
            color={quest.isLocked ? "gray" : quest.color!}
            points={quest.points}
          />
          {isCompletedRecurringQuest ? (
            <CompleteQuestCount
              color={quest.isLocked ? "gray" : quest.color!}
              completedCount={quest.completedCount!}
              recurringInterval={quest.recurringInterval}
              completed={completed}
            />
          ) : null}
        </div>
        <span className="h-[280px] flex items-center justify-center group-hover:hidden overflow-clip">
          {icon}
        </span>
        <span className="mt-[-5px] h-[200px]  overflow-clip hidden group-hover:flex items-center">
          {smallIcon}
        </span>
        <span className="mt-7 group-hover:mt-4">
          <span
            className={twMerge(
              `text-[24px] font-semibold text-center flex items-center justify-center group-hover:text-white xl:px-6 endemic:text-black`,
              textClass,
            )}
          >
            {quest.title}
          </span>
          <span
            className={twMerge(
              `mt-3 text-center text-body-3 font-normal hidden  group-hover:flex  group-hover:text-white`,
              textClass,
            )}
          >
            {quest.description}
          </span>
        </span>
      </QuestLink>
    </Tooltip>
  );
};

export default QuestCard;
